import { forkJoin, of } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { map, mergeMap, tap } from 'rxjs/operators';
// NGRX
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// Services
import { OrderEventsService } from '../_services/';
// State
import { AppState } from '../../reducers';
// Actions
import {
	OneOrderEventDeleted,
	OrderEventActionTypes,
	OrderEventCreated,
	OrderEventOnServerCreated,
	OrderEventsPageLoaded,
	OrderEventsPageRequested,
	OrderEventsPageToggleLoading,
	OrderEventUpdated
} from '../_actions/order-event.actions';

@Injectable()
export class OrderEventEffects {
	showPageLoadingDistpatcher = new OrderEventsPageToggleLoading({isLoading: true});
	showLoadingDistpatcher = new OrderEventsPageToggleLoading({isLoading: true});
	hideActionLoadingDistpatcher = new OrderEventsPageToggleLoading({isLoading: false});

	@Effect()
	loadOrderEventsPage$ = this.actions$
		.pipe(
			ofType<OrderEventsPageRequested>(OrderEventActionTypes.OrderEventsPageRequested),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showPageLoadingDistpatcher);
				const requestToServer = this.orderEventsService.findOrderEvents(payload.page);
				const lastQuery = of(payload.page);
				return forkJoin(requestToServer, lastQuery);
			}),
			map(response => {
				const result: QueryResultsModel = response[0];
				const lastQuery: QueryParamsModel = response[1];
				return new OrderEventsPageLoaded({
					OrderEvents: result.items,
					totalCount: result.totalCount,
					page: lastQuery
				});
			}),
		);

	constructor(private actions$: Actions, private orderEventsService: OrderEventsService, private store: Store<AppState>) {
	}
}
